export const CHANGE_APP_LANGUAGE = 'CHANGE_APP_LANGUAGE';
